export class EventCardHandler {
    private visibleContent: HTMLElement;
    private banner: Element;

    constructor(private element: HTMLElement) {
        this.visibleContent = this.element.getElementsByClassName(
            'event-card-expandable__visible-content'
        )[0] as HTMLElement;
        this.banner = this.element.getElementsByClassName('event-card-expandable__banner')[0];
        this.visibleContent.addEventListener('click', this);
    }

    handleEvent(_e: Event): void {
        this.visibleContent.classList.toggle('active');
        this.banner.classList.toggle('active');
    }

    remove(): void {
        this.visibleContent.removeEventListener('click', this);
        this.visibleContent = null;
        this.banner = null;
        this.element = null;
    }
}
